module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ds-month"
  }, [_c('div', {
    staticClass: "ds-week-header"
  }, _vm._l((_vm.weekdays), function(weekday, i) {
    return _c('div', {
      key: weekday,
      staticClass: "ds-week-header-day",
      class: _vm.weekdayClasses(i)
    }, [_vm._v("\n\n      " + _vm._s(weekday) + "\n\n    ")])
  })), _vm._v(" "), _vm._l((_vm.rows), function(i) {
    return _c('ds-day-row', _vm._g(_vm._b({
      key: i,
      attrs: {
        "days": _vm.daysAtRow(i, 7),
        "calendar": _vm.calendar,
        "placeholder": _vm.placeholder,
        "placeholder-for-create": _vm.placeholderForCreate
      }
    }, 'ds-day-row', {
      $scopedSlots: _vm.$scopedSlots
    }, false), _vm.$listeners))
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45f856ac","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WeeksView.vue
// module id = 164
// module chunks = 0